import { Component, OnChanges, Input, HostBinding } from '@angular/core';
import { AppService } from 'app/app.service';

declare const Mangler: any;

@Component({
	selector: 'ui-grid-header',
	template: `
		<div *ngIf="back && app.canGoBack()" class="mr-2">
			<a class="text-secondary selectable" style="text-decoration: none; font-size: 1.375rem; margin-left: -0.1875rem;" (click)="app.back()">
				<i class="wq wq-chevron-left"></i>
			</a>
		</div>
		<div *ngIf="path" class="py-2" [ngClass]="{ 'flex-weight-1': !compact, 'mr-3': compact }">
			<div class="text-lines lines-1">
				<ng-container *ngFor="let p of pathList; let first = first">
					<i *ngIf="!first" class="wq wq-angle-right text-secondary"></i>
					<a *ngIf="pathLink(p) as link; else plainCrumb" class="crumb-link selectable" [routerLink]="link" [ngbTooltip]="p.tooltip || ''"><b>{{p.text}}</b></a>
					<ng-template #plainCrumb><b>{{pathText(p)}}</b></ng-template>
				</ng-container>
				<span *ngIf="org" class="text-secondary"><i class="{{icon}} mx-2"></i> <b>{{app.orgInfo?.company_name}}</b></span>
			</div>
		</div>
		<div [ngClass]="{ 'flex-weight-1': !path || compact }">
			<ng-content></ng-content>
		</div>
		<a *ngIf="guideLink" class="text-secondary selectable ml-3" style="text-decoration: none; font-size: 1.375rem;"
			[routerLink]="guideLink" [fragment]="guideSection" ngbTooltip="Help guide" placement="left" aria-label="Help guide">
			<i class="wq wq-help"></i>
		</a>
	`,
	styles: [`
		:host { min-height: 2.3125rem; }
		.crumb-link, .crumb-link:hover { color: inherit; text-decoration: none; }
		.crumb-link:hover b { text-decoration: underline; }
	`]
})
export class UIGridHeaderComponent implements OnChanges {

	@Input() path;
	@Input() org = true;
	@Input() back = false;
	@Input() icon = 'wq wq-info';
	@Input() compact = false;
	// The module's help guide, opened at a section: 'crm#leads'.
	@Input() guide: string;

	@HostBinding('class') cls = 'd-flex my-2 align-items-center no-print';

	pathList = [];
	guideLink = null;
	guideSection = null;

	constructor(public app: AppService) { }

	ngOnChanges() {
		if (Mangler.isArray(this.path)) {
			this.pathList = this.path;
		} else {
			this.pathList = [this.path];
		}
		const [module, section] = (this.guide || '').split('#');
		this.guideLink = module ? ['/', this.app.org, module, 'guide'] : null;
		this.guideSection = section || null;
	}

	// A crumb is either a plain string or a { text, link, tooltip } object,
	// where link is anything routerLink accepts. Both helpers check for an object
	// first — a bare string would otherwise resolve `.link` to the legacy
	// String.prototype.link method and read as a linked crumb.
	pathText(p) {
		return (p && typeof p === 'object') ? p.text : p;
	}

	pathLink(p) {
		return (p && typeof p === 'object') ? p.link : null;
	}

}
